module.exports = __webpack_public_path__ + "static/media/mitm.41180f5a.jpg";